import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ModakBackdrop from "./ModakBackdrop";
import { useRoundGate } from "./useRoundGate";
import { ensureTimerStarted } from "./useElapsedTimer";

export default function Rules() {
  const navigate = useNavigate();
  const { loading, timerKey } = useRoundGate(null);

  useEffect(() => {
    document.title = "Modak Marathon";
  }, []);

  useEffect(() => {
    // Round 1's timer starts the moment the marathon begins, same as the old
    // gettime cookie that was first set on round1.php's first visit.
    ensureTimerStarted(timerKey);
  }, [timerKey]);

  if (loading) return null;

  return (
    <ModakBackdrop>
      <div className="modak-rules-card">
        <img src="/modak-assets/modak.gif" alt="Modak Marathon" />
        <div>
          <span className="modak-rules-heading">Rules</span>
        </div>
        <ul className="modak-rules-list">
          <li>Complete the Modak Marathon by covering the course</li>
          <li>On completing each level, the Modak becomes bigger and better</li>
          <li>Complete the whole marathon and celebrate the festivities</li>
        </ul>
        <button type="button" className="modak-btn" onClick={() => navigate("/home")}>
          Next
        </button>
      </div>
    </ModakBackdrop>
  );
}
